import { FETCHING, FETCHED, OUTDATED } from './constants'

export function fetching() {
    return { type: FETCHING }
}

export function fetched(creatives) {
    return {
        type: FETCHED,
        payload: creatives,
    }
}

export function outdated() {
    return { type: OUTDATED }
}



// WEBPACK FOOTER //
// ./src/features/Creatives/data/actions.js